import { mutate } from "swr"

import API from "./api"
import useCollection from "./useCollection"

import { useCurrentTLO } from "web/hooks/context"
import { isNonEmptyArray } from "web/services/helpers"

export default function useTopics({ subjectType = undefined } = {}) {
  const { data: TLO } = useCurrentTLO() || {}

  const root = "/topics"
  const path = subjectType ? `${root}/${subjectType}` : root

  // when using topics in global config, there is no TLO context
  const inTLOContext = !!TLO

  const topics = useCollection({
    key: path,
  })

  async function add(subjectType, data) {
    await API.post(path, { subject_type: subjectType, ...data })
    mutate(path)
  }

  if (!inTLOContext) {
    topics.add = add
    return topics
  }

  if (!isNonEmptyArray(topics)) return []

  return topics
}
